import React from 'react';
import Loader from 'components/Loader';
import Error from 'components/Error';
import { useThunkSelector } from 'utility/redux';

const TrialManagement = React.lazy(() =>
  import('../../dashboards/TrialManagement/TrialManagement'),
);

function TrialManagementRoute() {
  const pageAccess = useThunkSelector('moduleAccess');

  return (
    <React.Suspense fallback={<Loader className="my-5 py-5" />}>
      {pageAccess.isLoading && <Loader className="my-5 py-5" />}
      {pageAccess.isError && <Error error={pageAccess.error} />}
      {pageAccess.isSuccess && (
        <>
          {pageAccess.payload.trialManagement && <TrialManagement />}
          {!pageAccess.payload.trialManagement && <p>No Access</p>}
        </>
      )}
    </React.Suspense>
  );
}

export default TrialManagementRoute;
